import React from 'react';

const steps = [
  { num: '01', title: 'Register', desc: 'Guests enter their name and email on our digital scoreboard to get on the leaderboard.' },
  { num: '02', title: 'Putt', desc: 'Step up to the LED-lit putting lane and take your shots within the timed game window.' },
  { num: '03', title: 'Score', desc: 'Your score is captured automatically and displayed live on the guest leaderboard.' },
  { num: '04', title: 'Compete', desc: 'Track your position on the live leaderboard and battle your way to the top spot.' },
];

export default function HowItWorks() {
  return (
    <section id="how" className="how-section">
      <div className="container">
        <p className="section-label">Simple by Design</p>
        <h2 className="section-title">How It <span>Works</span></h2>
        <div className="steps-grid">
          {steps.map((s) => (
            <div className="step" key={s.num}>
              <div className="step-num">{s.num}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
